import React, { useEffect, useState } from 'react';

import { Link } from 'react-router-dom';

import ProfileIco from '../../Media/profile-icon.svg';
import ReelIco from '../../Media/reel-icon.svg';
import Stories from '../../Media/stories.svg';
import StoryIco from '../../Media/story-icon.svg';
import Video from '../../Media/video.svg';
import { useDownload } from '../../contexts/Download';
import * as routes from '../../routes';
export function NavigationMenu() {
  const [currentPage, setCurrentPage] = useState('');
  const { clickDownload, setClickDownload } = useDownload();
  function getIsActive(route) {
    if (String(currentPage) === route) {
      return currentPage;
    }
  }
  function getCurrentPageURL() {
    setClickDownload(false);
    let { pathname } = window.location;
    setCurrentPage(pathname);
  }
  useEffect(() => {
    getCurrentPageURL();
  }, []);
  return (
    <>
      <Link
        to={routes.VIDEO}
        className={`nav-buttons ${getIsActive(routes.VIDEO) ? 'active' : ''}`}
        activeClassName="active-navigation"
      >
        <img src={Video} className="nav-icons" alt="search profile" />
        {/* <Camera /> */}
        <p className="nav-name"> Video </p>
      </Link>
      <Link
        to={routes.FOTO}
        className={`nav-buttons ${getIsActive(routes.FOTO) ? 'active' : ''}`}
        activeClassName="active-navigation"
      >
        <img src={StoryIco} className="nav-icons" alt="search profile" />
        {/* <Camera /> */}
        <p className="nav-name"> Foto </p>
      </Link>
      <Link
        to={routes.REELS}
        className={`nav-buttons ${getIsActive(routes.REELS) ? 'active' : ''}`}
        activeClassName="active-navigation"
      >
        <img src={ReelIco} className="nav-icons" alt="search Reel" />
        <p className="nav-name"> Reels </p>
      </Link>
      <Link
        to={routes.STORY}
        className={`nav-buttons ${getIsActive(routes.STORY) ? 'active' : ''}`}
        activeClassName="active-navigation"
      >
        <img src={Stories} className="nav-icons" alt="search Story" />
        <p className="nav-name"> Story </p>
      </Link>

      {/* <Link
                to="/storydownload"
                className="nav-buttons"
                activeClassName="active-navigation"
            >
                <img src={StoryIco} className="nav-icons" alt="search Story" />
                <p className="nav-name"> Story Downloader </p>
            </Link> */}

      <Link
        to={routes.FEED}
        className={`nav-buttons ${getIsActive(routes.FEED) ? 'active' : ''}`}
        activeClassName="active-navigation"
      >
        <img src={ProfileIco} className="nav-icons" alt="search Post" />
        <p className="nav-name"> Perfil </p>
      </Link>

      {/* <Link
                to="/reeldownload"
                className="nav-buttons"
                activeClassName="active-navigation"
            >
                <img src={ReelIco} className="nav-icons" alt="search Reel" />
                <p className="nav-name"> Reel Downloader </p>
            </Link> */}

      {/* <Link
                to="/post"
                className="nav-buttons"
                activeClassName="active-navigation"
            >
                <img src={PostIco} className="nav-icons" alt="search Post" />
                <p className="nav-name"> Post viewer </p>
            </Link> */}

      {/* <Link
                to="/postdownload"
                className="nav-buttons"
                activeClassName="active-navigation"
            >
                <img src={PostIco} className="nav-icons" alt="search Post" />
                <p className="nav-name"> Post Downloader </p>
            </Link> */}

      {/* <Link
                to="/igtv"
                className="nav-buttons"
                activeClassName="active-navigation"
            >
                <img src={IgtvIco} className="nav-icons" alt="search Igtv" />
                <p className="nav-name"> Igtv Viewer </p>
            </Link>

            <Link
                to="/igtvdownload"
                className="nav-buttons"
                activeClassName="active-navigation"
            >
                <img src={IgtvIco} className="nav-icons" alt="search Igtv" />
                <p className="nav-name"> Igtv Downloader </p>
            </Link> */}

      {/* <Link
                to="/music"
                className="nav-buttons"
                activeClassName="active-navigation"
            >
                <img src={Music} className="nav-icons" alt="search Igtv" />
                <p className="nav-name"> Music </p>
            </Link> */}
    </>
  );
}

export default NavigationMenu;
